import { Button } from "@swot/base-components";

export function SwotRetryPanel(props: { readonly title?: string | undefined; readonly message?: string | undefined; readonly onRetry?: (() => void) | undefined }) {
  return (
    <section className="swot-retry-panel" role="alert">
      <h2>{props.title ?? "Retry available"}</h2>
      <p>{props.message ?? "The operation can be retried."}</p>
      {props.onRetry ? <Button label="Retry" variant="secondary" onClick={props.onRetry} /> : null}
    </section>
  );
}
